module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-cjdr.e36470de.png";